import React, { useState } from "react";
import "../../index.css";
import "../../App.css";
import { Row, Radio, Typography } from "antd";
import { painEntryFormConstants } from "../../helpers/painEntryFormConstants";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "./../../redux-toolkit/store/store";
import { handleChangePainDuration } from "../../redux-toolkit/slices/painEntryFormSlice";

const PainDurationSelector = () => {
  const selectedDuration = useSelector(
    (state: RootState) => state.painEntryForm.painDuration
  );
  const dispatch = useDispatch();
  const handleSelect = (value: string) => {
    dispatch(handleChangePainDuration(value));
  };

  return (
    <div className="flex flex-col gap-2">
      <label className="h6 text-theme-text-secondary">
        <strong>Pain duration *</strong>
      </label>
      <p className="body1 text-theme-text-primary mb-4">
        Select the option that best describes how long you've been experiencing the pain.
      </p>
      <Radio.Group
        onChange={(e) => handleSelect(e.target.value)}
        value={selectedDuration}
      >
        {painEntryFormConstants.painDuration.map(({ value, label }) => {
          return (
            <Radio key={value} value={value}>
              {label}
            </Radio>
          );
        })}
      </Radio.Group>
    </div>
  );
};

export default PainDurationSelector;
